import type { Cartesian3} from 'cesium';
import { Cartographic, Math as CesiumMath } from 'cesium';
import { EditingLock } from './constants';
import type { FeatureLockState } from './types';

export function radianToDegrees(x: number) {
  return CesiumMath.toDegrees(x).toFixed(7);
}

export function getCartographicDegreeFromCartesian(
  position: Cartesian3,
): Array<string> {
  const cartographic = Cartographic.fromCartesian(position);
  return [
    radianToDegrees(cartographic.longitude),
    radianToDegrees(cartographic.latitude),
  ];
}

/*
 * A polygon with holes reports per ring and multi-select reports per feature,
 * so only the states of features still in the selection count — which also
 * drops any entry a missed deselect left behind. Worst state wins.
 */
export const deriveEditingLock = (
  lockStates: Record<string, FeatureLockState>,
  selectedFeatureIds: string[],
): EditingLock => {
  const selectedIds = new Set(selectedFeatureIds);
  const selectedLockStates = Object.entries(lockStates)
    .filter(([featureId]) => selectedIds.has(featureId))
    .map(([, lockState]) => lockState);

  if (selectedLockStates.some(({ handlesVisible }) => !handlesVisible)) {
    return EditingLock.Hidden;
  }

  if (selectedLockStates.some(({ locked }) => locked)) {
    return EditingLock.Partial;
  }

  return EditingLock.None;
};
